// extracted by mini-css-extract-plugin
module.exports = {"dateBlock":"dateTimeBlock_dateBlock__31oBX","timeBlock":"dateTimeBlock_timeBlock__Le9ni","nowrap":"dateTimeBlock_nowrap__3rj2M"};